var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"mt-15",attrs:{"padless":""}},[_c('lazy-hydrate',{attrs:{"when-visible":""}},[_c('footer-lazy')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }